import { render, staticRenderFns } from "./DirectPurchase.vue?vue&type=template&id=7c56143e&scoped=true&"
import script from "./DirectPurchase.vue?vue&type=script&lang=js&"
export * from "./DirectPurchase.vue?vue&type=script&lang=js&"
import style0 from "./DirectPurchase.vue?vue&type=style&index=0&id=7c56143e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c56143e",
  null
  
)

export default component.exports